import type { ReactNode } from 'react'

import { Icon } from './Icon'
import { Text } from './Text'
import './system.css'

export function Empty({
  icon,
  title,
  body,
  children,
}: {
  icon?: string
  title?: string
  body: string
  children?: ReactNode
}) {
  return (
    <div className="empty-state">
      {icon ? <Icon size="lg">{icon}</Icon> : null}
      {title ? <Text role="title">{title}</Text> : null}
      <Text tone="muted" measure>
        {body}
      </Text>
      {children}
    </div>
  )
}
